'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ko_KR = require('../../date-picker/locale/ko_KR');

var _ko_KR2 = _interopRequireDefault(_ko_KR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _ko_KR2['default'];